














































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import Config from '@/config';
import SetupStatus from '@/models/SetupStatus';
import { mapGetters } from 'vuex';
import clients from '@/store/modules/clients';
import users from '@/store/modules/users';
import moment from 'moment';
import Client from '../../models/Client';
import Loading from '@/components/Loading.vue';

@Component({
  components: {
    Loading,
  },
})
export default class Reports extends Vue {
  private reportsList;
  private loading = true;
  private isAuthenticated;
  private totalRows = 1;
  private perPage = 10;
  private currentPage = 1;
  private tableItems: any[] = [];

  private fields = [
    { key: 'report date', sortable: true },
    { key: 'client', sortable: true },
    { key: 'report', sortable: true },
    { key: 'actions', label: 'Actions' },
  ];

  private async created() {
    try {
      const user = await users.getLoggedUser();
      if (!user) {
        await users.logout();
        this.$router.push({ name: 'login' });
      } else {
        await this.prepareComponent();
      }
    } catch (error) {
      return error;
    }
  }

  private async prepareComponent() {
    try {
      this.reportsList = await clients.getReports();
      this.reportsList = this.reportsList.data.filter((elem) =>
        elem.includes('.pdf'),
      );
      this.totalRows = this.reportsList.length;
      this.loading = false;
      this.$forceUpdate();
    } catch (error) {
      return error;
    }
  }

  private details(row) {
    window.open(Config.baseApiUrl + '/reports/' + row.item.report, '_blank');
  }

  private beforeUpdate() {
    this.tableItems = this.convertToItems();
  }

  private convertToItems() {
    const items: any = [];
    this.reportsList.forEach((report) => {
      const parts = report.split('-');
      const client = parts[0];
      const date = moment.unix(
        parseInt(parts[1].substring(0, parts[1].length - 4)) / 1000,
      );
      const elem = {
        'report date': date.format('DD-MM-YYYY HH:mm:ss'),
        client,
        report,
        id: report.id,
      };
      items.push(elem);
    });
    return items;
  }
}
